import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Slider from 'react-slick';
import Slide from './Slide/Slide';
import GetBannersQuery from '../Query/Banners';
import { buildBannerLink } from '../../helpers/banners/buildBannerLink';
import CountryService from '../../services/CountryService';
import { canUseDOM } from '../../utils';

const settings: object = {
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

interface ICarouselProps extends RouteComponentProps<{ language: string }> {}

class Carousel extends React.Component<ICarouselProps> {
  public render() {
    const { language, countryCode } = CountryService.GetInstance();

    return (
      <GetBannersQuery>
        {({ banners }: any) => {
          if (banners && banners.banners) {
            return (
              <Slider className="carousel" {...settings}>
                {banners.banners
                  .filter((b: GQL.IBanner) => b.type.toString() === 'HomePageHeader')
                  .map((banner: GQL.IBanner, index: number) => {
                    return (
                      <Slide
                        key={banner.id}
                        id={index}
                        img={banner.file}
                        title={banner.title[language] || ''}
                        subtitle={banner.subtitle[language] || ''}
                        description={banner.description[language] || ''}
                        productImage={banner.productImage || ''}
                        link={buildBannerLink(banner, countryCode)}
                      />
                    );
                  })}
              </Slider>
            );
          }

          if (canUseDOM() && ('querySelector' in document)) {
            const ssrCarousel = document.querySelector('.contentWrapper .carousel');
            if (ssrCarousel) {
              const ssrContent = ssrCarousel.innerHTML;
              const ssrClasses = ssrCarousel.className;
              return <div className={ssrClasses} dangerouslySetInnerHTML={{ __html: ssrContent }} />;
            }
          }

          return null;
        }}
      </GetBannersQuery>
    );
  }
}

export default withRouter(Carousel);



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.tsx